// extracted by mini-css-extract-plugin
export default {"goal-card":"GoalCard_goal-card__fXiVN","icon":"GoalCard_icon__jW10D","description":"GoalCard_description__DX1pi"};